import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { IAppContext } from '@kurtosys/types/helpers/AnalyticsHelper/IAppContext.js';

export const AnalyticsContext = React.createContext<common.helpers.AnalyticsHelper<IAppContext> | undefined>(
	new common.helpers.AnalyticsHelper<IAppContext>(() => {
		return {
			appTemplate: 'unknown',
			appGuid: 'unknown',
			configurationKey: 'unknown',
		};
	}),
);
